/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { LeadWaitlistDetails } from './LeadWaitlistDetails';
import {
    LeadWaitlistDetailsFromJSON,
    LeadWaitlistDetailsFromJSONTyped,
    LeadWaitlistDetailsToJSON,
} from './LeadWaitlistDetails';
import type { LeadWaitlistUpdatesInner } from './LeadWaitlistUpdatesInner';
import {
    LeadWaitlistUpdatesInnerFromJSON,
    LeadWaitlistUpdatesInnerFromJSONTyped,
    LeadWaitlistUpdatesInnerToJSON,
} from './LeadWaitlistUpdatesInner';
import type { User } from './User';
import {
    UserFromJSON,
    UserFromJSONTyped,
    UserToJSON,
} from './User';

/**
 * 
 * @export
 * @interface LeadWaitlist
 */
export interface LeadWaitlist {
    /**
     * 
     * @type {string}
     * @memberof LeadWaitlist
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof LeadWaitlist
     */
    lead_id?: string;
    /**
     * 
     * @type {string}
     * @memberof LeadWaitlist
     */
    status?: LeadWaitlistStatusEnum;
    /**
     * 
     * @type {LeadWaitlistDetails}
     * @memberof LeadWaitlist
     */
    details?: LeadWaitlistDetails;
    /**
     * 
     * @type {number}
     * @memberof LeadWaitlist
     */
    rank?: number;
    /**
     * 
     * @type {string}
     * @memberof LeadWaitlist
     */
    created_at?: string;
    /**
     * 
     * @type {User}
     * @memberof LeadWaitlist
     */
    status_set_by_user?: User;
    /**
     * 
     * @type {string}
     * @memberof LeadWaitlist
     */
    receipt_id?: string;
    /**
     * 
     * @type {Array<LeadWaitlistUpdatesInner>}
     * @memberof LeadWaitlist
     */
    updates?: Array<LeadWaitlistUpdatesInner>;
}


/**
 * @export
 */
export const LeadWaitlistStatusEnum = {
    Waitlisted: 'Waitlisted',
    Cleared: 'Cleared',
    Cancelled: 'Cancelled'
} as const;
export type LeadWaitlistStatusEnum = typeof LeadWaitlistStatusEnum[keyof typeof LeadWaitlistStatusEnum];


/**
 * Check if a given object implements the LeadWaitlist interface.
 */
export function instanceOfLeadWaitlist(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function LeadWaitlistFromJSON(json: any): LeadWaitlist {
    return LeadWaitlistFromJSONTyped(json, false);
}

export function LeadWaitlistFromJSONTyped(json: any, ignoreDiscriminator: boolean): LeadWaitlist {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'lead_id': !exists(json, 'lead_id') ? undefined : json['lead_id'],
        'status': !exists(json, 'status') ? undefined : json['status'],
        'details': !exists(json, 'details') ? undefined : LeadWaitlistDetailsFromJSON(json['details']),
        'rank': !exists(json, 'rank') ? undefined : json['rank'],
        'created_at': !exists(json, 'created_at') ? undefined : json['created_at'],
        'status_set_by_user': !exists(json, 'status_set_by_user') ? undefined : UserFromJSON(json['status_set_by_user']),
        'receipt_id': !exists(json, 'receipt_id') ? undefined : json['receipt_id'],
        'updates': !exists(json, 'updates') ? undefined : ((json['updates'] as Array<any>).map(LeadWaitlistUpdatesInnerFromJSON)),
    };
}

export function LeadWaitlistToJSON(value?: LeadWaitlist | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'lead_id': value.lead_id,
        'status': value.status,
        'details': LeadWaitlistDetailsToJSON(value.details),
        'rank': value.rank,
        'created_at': value.created_at,
        'status_set_by_user': UserToJSON(value.status_set_by_user),
        'receipt_id': value.receipt_id,
        'updates': value.updates === undefined ? undefined : ((value.updates as Array<any>).map(LeadWaitlistUpdatesInnerToJSON)),
    };
}

